import { render, staticRenderFns } from "./MaintenanceHistory.vue?vue&type=template&id=54f5bdc0&scoped=true&"
import script from "./MaintenanceHistory.vue?vue&type=script&lang=js&"
export * from "./MaintenanceHistory.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceHistory.vue?vue&type=style&index=0&id=54f5bdc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5bdc0",
  null
  
)

export default component.exports